import { COMMON } from "../../constants/action-types";

const initialState = {
    dropDownItems: [],
    clientId: null,
    client_information: [],
    countsPeopleCustomerProspect: [],
    totalContactsCard: [],
    recentDataLoads: [],
    recentDataLoadsTab: [],
    recentDataSources: [],
    user_information: [],
    client_providers:null,
    clientDropDown: [],
    clientUserClaims: [],
    includeCongloms: false,
    menuClickInformation : null,//{ parentId : null, childId : null, innerChildId : null}
    designGuid:null,
    preventNonAlphaNumericValue:  /^[a-zA-Z0-9\[\]\{\}]+$/,
    defualtValues: []

}

const CommonReducer = (state = initialState, action) => {
    switch (action.type) {
        case COMMON.PROVIDERS: {
            return Object.assign({}, state, {
                client_providers: action.payload
            });

        }
        case COMMON.UPDATE_TOTAL_CONTACTS: {
            return Object.assign({}, state, {
                totalContactsCard: action.payload
            });

        }
        case COMMON.DROP_DOWN_FILL: {
            return Object.assign({}, state, {
                dropDownItems: action.payload
            });

        }
        case COMMON.DROP_DOWN_CLICK: {
            localStorage.setItem("brandId",action.payload)
            return Object.assign({}, state, {
                clientId: action.payload
            });

        }
        case COMMON.GET_CLIENT: {
            return Object.assign({}, state, {
                client_information: action.payload
            });
        }
        case COMMON.COUNTS_FOR_PEOPLE_CUSTOMER_PROSPECT: {
            return Object.assign({}, state, {
                countsPeopleCustomerProspect: action.payload
            });

        }
        case COMMON.RECENT_LOADS_UPDATE: {
            return Object.assign({}, state, {
                recentDataLoads: action.payload.recentDataLoads,
                recentDataLoadsTab: action.payload.recentDataLoadsTab
            });

        }
        case COMMON.RECENT_SOURCES_UPDATE: {
            return Object.assign({}, state, {
                recentDataSources: action.payload
            });

        }
        case COMMON.GET_USER: {
            return Object.assign({}, state, {
                user_information: action.payload
            });

        }
        case COMMON.GET_CLIENT_LIST: {
            return Object.assign({}, state, {
                clientDropDown: action.payload
            });

        }
        case COMMON.GET_CLIENT_USER_CLAIMS: {
            return Object.assign({}, state, {
                clientUserClaims: action.payload
            });

        }
        case COMMON.INCLUDE_CONGLOMS: {
            return Object.assign({}, state, {
                includeCongloms: action.payload
            });

        }
        case COMMON.MENU_CLICK_INFORMATION: {
            return Object.assign({}, state, {
                menuClickInformation: action.payload
            });

        }
        case COMMON.DESIGN_GUID: {
            return Object.assign({}, state, {
                designGuid: action.payload
            });

        }
        case COMMON.INSERT_PORTAL_ACCESS_LOG: {
            return Object.assign({}, state, {
                insertPortalAccessLogStatus : action.payload
            });

        }
        case COMMON.GET_DEFUALT_VALUES: {
            return Object.assign({}, state, {
              defualtValues: action.payload,
            });
          }  

        default:
            return state
    }

}

export default CommonReducer